import { useQuery, UseQueryOptions } from 'react-query';

import { QueryKeys } from '.';
import { useApi } from '../../context';
import { AxiosUtils } from '../../utils';
import { Guid, BankDealProfile } from '../../models';
import { CerebroApiEndpoints } from '../../utils/api';

export function useBankDealProfileFromContactQuery(
	bankGuid: Guid | undefined,
	bankContactGuid: Guid | undefined,
	options?: Omit<UseQueryOptions<BankDealProfile, unknown, BankDealProfile, any>, 'queryKey' | 'queryFn'> | undefined
) {
	const api = useApi();

	return useQuery(
		QueryKeys.Banks.BankDealProfile(bankGuid, bankContactGuid),
		() =>
			AxiosUtils.getResponseData<BankDealProfile>(
				api.get(CerebroApiEndpoints.Banks.BankDealProfile(bankGuid, bankContactGuid))
			),
		options
	);
}
